/**
 * tokenMap — single source-of-truth eşleme tablosu.
 *
 * 18 shadcn CSS-var key (mevcut `ui_tokens` seed'i + `web/src/index.css` :root ile birebir)
 * ile kanonik W3C DTCG token path'leri arasındaki köprü.
 *
 * Kanonik DTCG convention (bu PR'da SEÇİLDİ — sonraki PR'lar Brand DTCG'yi buna normalize edecek):
 *
 *   - Renk token'ları `color.<role>` ağacında, dot-path ile:
 *       `--primary`             -> `color.primary`
 *       `--primary-foreground`  -> `color.primary.foreground`
 *   - "<role>-foreground" CSS-var'ları, ilgili rolün altında `foreground` çocuğu olarak modellenir
 *     (DTCG group içinde değer + alt-token; `color.primary` hem DEFAULT renk hem `foreground` çocuğu taşır).
 *   - Group default değeri için W3C DTCG `$value`'yu temsil eden `DEFAULT` segment'i KULLANILMAZ;
 *     bunun yerine path doğrudan rol node'una işaret eder ve resolveTokenValue group'un kendi `$value`/
 *     `value`'sunu okur (bkz. dtcgToCssVars). Bu, Brand DTCG'nin `color.primary = { value, foreground }`
 *     şeklindeki ağaç formatıyla uyumludur.
 *   - Non-color: `--radius` -> `radius` (tek seviye; passthrough, transform yok).
 *
 * NOT: `--popover` / `--popover-foreground` bu tabloda YOK — ne `ui_tokens` seed'inde
 * (migrate.ts:1108-1167) ne de `web/src/index.css`'te tanımlı (kaynak gerçeği 18 key).
 * Eklenmesi gerekirse ayrı karar + seed migration ister.
 */
/**
 * 18 girişlik kanonik eşleme. Sıra deterministik (çıktı obje key sırası bununla eşleşir).
 * Renk: 17 · Dimension: 1.
 */
export const TOKEN_MAP = [
    { cssVar: '--background', dtcgPath: 'color.background', kind: 'color' },
    { cssVar: '--foreground', dtcgPath: 'color.foreground', kind: 'color' },
    { cssVar: '--card', dtcgPath: 'color.card', kind: 'color' },
    { cssVar: '--card-foreground', dtcgPath: 'color.card.foreground', kind: 'color' },
    { cssVar: '--primary', dtcgPath: 'color.primary', kind: 'color' },
    { cssVar: '--primary-foreground', dtcgPath: 'color.primary.foreground', kind: 'color' },
    { cssVar: '--secondary', dtcgPath: 'color.secondary', kind: 'color' },
    { cssVar: '--secondary-foreground', dtcgPath: 'color.secondary.foreground', kind: 'color' },
    { cssVar: '--muted', dtcgPath: 'color.muted', kind: 'color' },
    { cssVar: '--muted-foreground', dtcgPath: 'color.muted.foreground', kind: 'color' },
    { cssVar: '--accent', dtcgPath: 'color.accent', kind: 'color' },
    { cssVar: '--accent-foreground', dtcgPath: 'color.accent.foreground', kind: 'color' },
    { cssVar: '--destructive', dtcgPath: 'color.destructive', kind: 'color' },
    { cssVar: '--destructive-foreground', dtcgPath: 'color.destructive.foreground', kind: 'color' },
    { cssVar: '--border', dtcgPath: 'color.border', kind: 'color' },
    { cssVar: '--input', dtcgPath: 'color.input', kind: 'color' },
    { cssVar: '--ring', dtcgPath: 'color.ring', kind: 'color' },
    { cssVar: '--radius', dtcgPath: 'radius', kind: 'dimension' },
];
/**
 * DTCG path → eşleme girişi hızlı arama tablosu.
 * Çoklu CSS-var aynı path'e mantıken işaret etmediği için (1:1), path key olarak güvenli.
 */
export const DTCG_PATH_TO_ENTRY = new Map(TOKEN_MAP.map((entry) => [entry.dtcgPath, entry]));
/** Tüm bilinen shadcn CSS-var key'leri (deterministik sıra). */
export const KNOWN_CSS_VARS = TOKEN_MAP.map((e) => e.cssVar);
//# sourceMappingURL=tokenMap.js.map